/* eslint-disable */
import { endpoints } from '../Constants';
import { authHeader } from '../Helpers';
import handleResponse from './helpers';
import notificationServices from './notification.services';

// Internal-only App Versions page. The backend ignores the domain's clientId and checks that the
// user holds an internal role, so these calls work the same from any console domain.

function listAppVersions() {
	return fetch(endpoints.APP_VERSIONS, {
		method: 'GET',
		headers: authHeader(),
	}).then(handleResponse);
}

// XHR instead of fetch so the page can show progress while a large APK uploads.
function uploadAppBuild({ file, version, releaseNotes, releaseNotesLink }, onProgress) {
	const form = new FormData();
	form.append('file', file);
	form.append('version', version);
	if (releaseNotes) form.append('releaseNotes', releaseNotes);
	if (releaseNotesLink) form.append('releaseNotesLink', releaseNotesLink);

	return new Promise((resolve, reject) => {
		const fail = (message) => {
			notificationServices.generateNotification({ type: 'error', message });
			reject(message);
		};
		const xhr = new XMLHttpRequest();
		xhr.open('POST', endpoints.APP_VERSIONS_UPLOAD);
		const headers = authHeader();
		Object.keys(headers).forEach((key) => {
			if (headers[key] != null) xhr.setRequestHeader(key, headers[key]);
		});
		xhr.upload.onprogress = (e) => {
			if (e.lengthComputable && onProgress) onProgress(Math.round((e.loaded / e.total) * 100));
		};
		xhr.onerror = () => fail('Upload failed - check your connection and try again');
		xhr.onload = () => {
			try {
				JSON.parse(xhr.responseText);
			} catch (e) {
				// nginx answers 413 / 502 with HTML, which handleResponse can't parse
				fail(xhr.status === 413 ? 'The file is larger than the server accepts' : `Upload failed (HTTP ${xhr.status})`);
				return;
			}
			// Reuse the shared handling (error toast, logout on 403) with a fetch-like response
			handleResponse({ text: () => Promise.resolve(xhr.responseText) }).then(resolve, reject);
		};
		xhr.send(form);
	});
}

function assignAppVersion({ customerId, appVersionId, forceUpdate }) {
	return fetch(endpoints.APP_VERSIONS_ASSIGN, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({ customerId, appVersionId, forceUpdate }),
	}).then(handleResponse);
}

// Soft delete: the API refuses while any customer, store or the global default still uses the version
function deleteAppVersion({ appVersionId }) {
	return fetch(endpoints.APP_VERSIONS_DELETE, {
		method: 'POST',
		headers: {
			'Content-Type': 'application/json',
			...authHeader(),
		},
		body: JSON.stringify({ appVersionId }),
	}).then(handleResponse);
}

const appVersionsServices = {
	listAppVersions,
	uploadAppBuild,
	assignAppVersion,
	deleteAppVersion,
};

export default appVersionsServices;
